var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M5 4L0.669873 0.25L9.33013 0.250001L5 4Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }